import React from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { useI18n } from "@/i18n";

export const useSiteSettings = () =>
  useQuery({ queryKey: ["site-settings"], queryFn: async () => (await api.get("/settings")).data, staleTime: 300000 });

export function BetaBadge({ className = "" }) {
  const { t } = useI18n();
  const { data } = useSiteSettings();
  if (data && !data.beta_enabled) return null;
  return (
    <span
      data-testid="beta-badge"
      title={t("beta.notice")}
      className={`inline-flex items-center px-1.5 py-[3px] rounded-md border border-violet-300/70 bg-violet-50 text-violet-700 font-mono text-[9px] font-bold tracking-[0.16em] leading-none select-none ${className}`}
    >
      {t("beta.badge")}
    </span>
  );
}

export function BetaNotice({ className = "" }) {
  const { t } = useI18n();
  const { data } = useSiteSettings();
  if (data && !data.beta_enabled) return null;
  return (
    <p data-testid="beta-notice" className={`text-xs text-violet-700 bg-violet-50 border border-violet-100 rounded-lg px-3 py-2 leading-relaxed ${className}`}>
      <span className="font-mono font-bold tracking-wider me-1.5">{t("beta.badge")}</span>{t("beta.notice")}
    </p>
  );
}
